import { trackDigitalEvent } from '@sparknz/tracking';

type TrackApplyFilterParameter = {
  numFilters: number;
  selectedBrandValues: string[];
  selectedColorValues: string[];
  selectedPrice: number;
  selectedSubcategoryId: string;
};

export function trackApplyFilterEvent({
  numFilters,
  selectedBrandValues,
  selectedColorValues,
  selectedPrice,
  selectedSubcategoryId,
}: TrackApplyFilterParameter) {
  trackDigitalEvent({
    event: 'shop.productApplyFilter',
    w3cddl: {
      event: [
        {
          eventInfo: {
            eventName: 'Shop Product Apply Filter',
            eventAction: 'shop.productApplyFilter',
          },
          attributes: {
            viewResultPrimaryCTA: 'Yes',
            filterInfo: {
              primaryCategory: selectedSubcategoryId,
              category: selectedSubcategoryId,
              numOfCategory: '1',
              colors: selectedColorValues,
              numOfcolors: selectedColorValues?.length.toString(),
              brands: selectedBrandValues,
              numOfBrands: selectedBrandValues?.length.toString(),
              priceMin: '0',
              priceMax: selectedPrice?.toString(),
              sortBy: 'desc', // @TODO confirm this
              numOFFilters: numFilters.toString(),
            },
          },
        },
      ],
    },
  });
}
